module.exports = __webpack_public_path__ + "img/12.e6812b39.jpg";